import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { Country as CountryType } from '@ps/web-core-intl';

import countries from '@swf/generated/countries.json';

const comRecognisedCountries = countries.filter(
  (country: { value: string }) => !['HR'].includes(country.value)
);

const ukCountries = countries.filter((country: { value: string }) =>
  ['GB', 'JE', 'GI', 'GG'].includes(country.value)
);

export const getCountries = (site: Sites, country?: string): CountryType[] => {
  switch (site) {
    case Sites.COM:
      return comRecognisedCountries;
    default:
      return ukCountries.find((ukCountry: { value: string }) => ukCountry.value === country)
        ? ukCountries
        : countries;
  }
};
